export default __webpack_public_path__ + "static/media/default_course-img.b0887da4.svg";